import * as actionTypes from './actionTypes';

const initialState = {
  paytmCitiesMap: null,
  cancellationOffersList: [],
  routeServices: [],
  offerData: null,
}

// for edit case, filter out all the routes which belogs to another source and destination
const filterServices = function(routeId, services) {
  const [sourceId, destId] = routeId.split('-');
  return services.filter(el => el.provider_source_id == sourceId && el.provider_destination_id == destId);
}

export default (state = initialState, { type, payload }) => {
  switch(type) {
    case actionTypes.PAYTM_CITIES_DATA: {
      return {
        ...state,
        paytmCitiesMap: payload.data.reduce((acc, el) => { acc[el.id] = el.name; return acc;}, {})
      }
    }

    case actionTypes.CANCELLATION_OFFER_LIST: {
      let data = payload.data;
      // split paytm_route, store source and dest ids separately for fast rendering in table
      data.forEach(el => {
        let [sourceId, destId] = el.paytm_route.split('-');
        el.sourceId = sourceId;
        el.destId = destId;
        el.timeWindow = el.new_format_policy[0].end_time/60;
      })
      return {
        ...state,
        cancellationOffersList: data
      }
    }

    case actionTypes.OFFER_DATA: {
      let services = state.routeServices, offerData = payload.data;
      if(services.length && payload.data.route_id) {
        services = filterServices(payload.data.route_id, services)
      }
      offerData.hoursBeforeDep = offerData.new_format_policy[0].end_time/60;
      return { ...state, offerData: offerData, routeServices: services || [] }
    }

    case actionTypes.ROUTE_SERVICES: {
      let services = payload.data.body;
      if(state.offerData && state.offerData.route_id && services && services.length) {
        services = filterServices(state.offerData.route_id, services)
      }
      return { ...state, routeServices: services || [] }
    }

    case actionTypes.CLEAR_CANCELLATION_OFFER_DATA:
      return initialState;

    default:
      return state
  }
}